// extracted by mini-css-extract-plugin
export default {"label":"InputNormalEL_label__G1pTZ","noStepper":"InputNormalEL_noStepper__WEFQJ","errorInput":"InputNormalEL_errorInput__Ch7ag","errorText":"InputNormalEL_errorText__sDlZm"};